<template>
  <div
    class="form-check"
    style="text-align: right;">
    <input
      :id="id"
      style="border:solid;"
      class="form-check-input position-static"
      type="checkbox"
      aria-label="..."
      :disabled="disabled"
      :checked="checked"
      @input="onInput">
    <label
      :for="id"
      class="big-check-box__label"
      :class="{'big-check-box__label--disabled': disabled}" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput() {
      this.$emit('input')
    }
  }
}
</script>

<style lang="scss" scoped>
.big-check-box__label,
.big-check-box__label--disabled {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  position: relative;
  width: auto;
  &:before {
    background: #fff;
    border: 1px solid $grey05;
    content: '';
    display: block;
    height: 26px;
    margin-top: -10px;
    position: absolute;
    top: 50%;
    width: 26px;
    border-radius: 4px;
    right: 0; 
  }
  &:after {
    border-right: 4px solid $l-blue;
    border-bottom: 4px solid $l-blue;
    content: '';
    display: block;
    height: 16px;
    margin-top: -7px;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: rotate(45deg);
    width: 10px;
    border-radius: 2px;
    right: 7px;
  } 
}

.big-check-box__label--disabled:before {
  background: $grey03;
}

.big-check-box__label--disabled:after {
  border-color: $grey05;
}

input[type="checkbox"]{
  display: none;
}

input[type=checkbox]:checked + .big-check-box__label:after {
    opacity: 1;
}
</style>